/**
 * What a funnel answer is called on the Mixpanel PROFILE.
 *
 * Events keep the raw question keys, because an event is a record of what
 * happened and renaming it later would break every saved report. A profile is
 * read by a person choosing a segment from a dropdown, so the names here are
 * the ones that make sense in that dropdown — and both funnels write into the
 * same namespace, so a parent who has been through each is one row, not two.
 *
 * Anything not in this table is written under its own key rather than dropped:
 * a new question should show up in Mixpanel the day it ships, even if nobody
 * has given it a nice name yet.
 */
export const PROFILE_KEYS: Record<string, string> = {
  // ── the main funnel ────────────────────────────────────────────────────────
  pronouns: 'Child Pronouns',
  age: 'Child Age',
  topics: 'Topics',
  moods: 'Story Moods',
  pace: 'Viewing Pace',
  faith: 'Faith Opt In',
  faithGroup: 'Faith Tradition',
  faithBranch: 'Faith Branch',
  family: 'Family',

  // ── the faith funnel ───────────────────────────────────────────────────────
  gender: 'Child Gender',
  relationship: 'Relationship To Child',
  'faith-bond': 'Child Faith',
  goals: 'Goals',
  denomination: 'Denomination',
  'parent-faith': 'Parent Faith',
  frequency: 'Explores Faith',
  bedtime: 'Bedtime Routine',
  envision: 'Four Week Hope',
};

/** The profile name for an answer key, or the key itself if it has no nice one. */
export const profileKey = (question: string): string => PROFILE_KEYS[question] ?? question;
